import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/copy-icon.svg'
import _imports_1 from '@/assets/images/date-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-cab88b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overviewCon" }
const _hoisted_2 = { class: "searchCon" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "VIN", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text" }, "Retail Date", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Dealer Code", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " ", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Start")
const _hoisted_9 = { class: "searchCon" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sample Size", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, " ", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Start")
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "exportCon" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Export Search Result")
const _hoisted_16 = { class: "table-box" }
const _hoisted_17 = {
  key: 0,
  class: "bottom"
}
const _hoisted_18 = { class: "batch-query-title" }
const _hoisted_19 = { style: {"padding":"0 8px"} }
const _hoisted_20 = { class: "list-title" }
const _hoisted_21 = { class: "list-content" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Clear")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Confirm")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, {
      class: "titleBG",
      dataSource: [{ name: 'SICCO Checking Sampling' }]
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tabs, {
        activeKey: _ctx.activeKey,
        "onUpdate:activeKey": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.activeKey) = $event)),
        onChange: _ctx.changeTab
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_tab_pane, {
            key: "1",
            tab: "Manual"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_space, { direction: "vertical" }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.manualParams.vinNo,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.manualParams.vinNo) = $event)),
                          placeholder: "Please input",
                          maxlength: 17,
                          style: {"width":"180px"}
                        }, null, 8, ["value"]),
                        _createElementVNode("img", {
                          src: _imports_0,
                          style: {"margin":"0 8px 0 -4px","cursor":"pointer"},
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.batchQueryEvent && _ctx.batchQueryEvent(...args)))
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  class: "mr10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_4,
                    _createVNode(_component_a_range_picker, {
                      style: {"width":"210px"},
                      placeholder: ['Start date', 'End date'],
                      valueFormat: "YYYY/MM/DD",
                      format: "YYYY/MM/DD",
                      value: _ctx.manualParams.retailDatePeriod,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.manualParams.retailDatePeriod) = $event))
                    }, {
                      suffixIcon: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  class: "mr10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6,
                    _createVNode(_component_a_input, {
                      value: _ctx.manualParams.dealerCode,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.manualParams.dealerCode) = $event)),
                      placeholder: "Please input",
                      style: {"width":"210px"}
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  class: "right-button"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "button noMargin",
                      onClick: _ctx.getManualTable
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_tab_pane, {
            key: "2",
            tab: "Random"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  class: "mr10"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createVNode(_component_a_input, {
                      value: _ctx.sampleSize,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.sampleSize) = $event)),
                      placeholder: "Please input",
                      style: {"width":"210px"},
                      onChange: _ctx.sampleSizeChange
                    }, null, 8, ["value", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_space, {
                  direction: "vertical",
                  class: "right-button"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _createVNode(_component_a_button, {
                      type: "primary",
                      class: "button noMargin",
                      onClick: _ctx.getRandomTable
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["activeKey", "onChange"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_a_button, {
          class: "button noMargin",
          onClick: _ctx.exportSearchResult
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_a_table, {
          columns: _ctx.columns,
          pagination: false,
          dataSource: _ctx.tableData,
          rowKey: "id",
          scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight },
          rowClassName: 
                    (record, index) =>
                        index % 2 === 1 ? 'table-striped' : null
                
        }, null, 8, ["columns", "dataSource", "scroll", "rowClassName"])
      ])
    ]),
    (_ctx.tableData && _ctx.tableData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_a_pagination, {
            total: _ctx.pagination.total,
            "show-size-changer": "",
            "show-total": (total) => `共 ${total} 条`,
            onChange: _ctx.pageChange,
            onShowSizeChange: _ctx.sizeChange,
            current: _ctx.pagination.currentPage,
            "onUpdate:current": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pagination.currentPage) = $event)),
            pageSize: _ctx.pagination.pageSize,
            "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pagination.pageSize) = $event)),
            pageSizeOptions: ['10', '20', '30', '40', '50']
          }, {
            buildOptionText: _withCtx((props) => [
              _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
            ]),
            _: 1
          }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "current", "pageSize"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.batchQuery.batchQueryModal,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.batchQuery.batchQueryModal) = $event)),
      width: 420,
      onCancel: _ctx.closeBatchQueryModal,
      class: "batch-query-modal",
      centered: ""
    }, {
      title: _withCtx(() => [
        _createElementVNode("strong", _hoisted_18, _toDisplayString(_ctx.batchQuery.batchQueryTitle), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _ctx.clearBatchQuery
        }, {
          default: _withCtx(() => [
            _hoisted_22
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          size: "small",
          type: "primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => {
                    _ctx.batchQuery.batchQueryModal = false;
                    _ctx.closeBatchQueryModal();
                })
        }, {
          default: _withCtx(() => [
            _hoisted_23
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("article", null, [
            _createElementVNode("section", _hoisted_20, _toDisplayString(_ctx.batchQuery.batchQueryListTitle), 1),
            _createElementVNode("section", _hoisted_21, [
              (_ctx.textNoArray.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.textNoArray, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-item",
                      key: index
                    }, _toDisplayString(item), 1))
                  }), 128))
                : _createCommentVNode("", true),
              _createVNode(_component_a_input, {
                ref: "input",
                value: _ctx.textContentNo,
                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.textContentNo) = $event)),
                onChange: _ctx.textChangEvent,
                style: {"height":"24px"}
              }, null, 8, ["value", "onChange"]),
              (_ctx.batchPlaceholder.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.batchPlaceholder, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "list-item",
                      style: {"height":"24px","margin-top":"8px"}
                    }))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"])
  ], 64))
}